import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppTableContainer from '@nxsys/components/AppTableContainer';
import { IAepnUpload, IAepnUploadRecord } from '@nxsys/types/models/aepn/upload';
import { Descriptions, Typography } from 'antd';
import React from 'react';
import { uploadRecordColumns } from './upload-record-columns';

const { Text } = Typography;

type UploadDetailData = Omit<IAepnUpload, 'uploadedBy'> & {
  fileSize?: number;
  fileUrl?: string;
  rawData?: { data?: { aepnResponseBody?: { aepnDataset?: IAepnUploadRecord[] } } };
  uploadedBy?: { forename?: string; surname?: string };
};

type UploadDetailModalProps = {
  isOpen: boolean;
  toggle: () => void;
  data: UploadDetailData | null;
};

const UploadDetailModal: React.FC<UploadDetailModalProps> = ({ isOpen, toggle, data }) => {
  if (!data) return null;

  const { fileName, fileSize, totalRecords, errorMessage } = data;
  const records: IAepnUploadRecord[] = data?.rawData?.data?.aepnResponseBody?.aepnDataset || [];

  return (
    <AppModalContainer
      title="Upload Detail"
      isOpen={isOpen}
      toggle={toggle}
      width="90%"
      minHeight="0px"
      hiddenFooter
    >
      <Descriptions className="mb-4" column={3} size="small" bordered>
        <Descriptions.Item label="File Name">{fileName || '_'}</Descriptions.Item>
        {!!fileSize && (
          <Descriptions.Item label="File Size">
            {`${Math.round(fileSize / 1024)} KB`}
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Total Records">{totalRecords ?? '_'}</Descriptions.Item>
        {errorMessage && (
          <Descriptions.Item label="Error" span={3}>
            <Text type="danger">{errorMessage}</Text>
          </Descriptions.Item>
        )}
      </Descriptions>

      <AppTableContainer
        rowKey={(_, idx) => String(idx)}
        data={records}
        loading={false}
        page={0}
        total={records.length}
        pageSize={records.length || 10}
        columns={uploadRecordColumns}
        scroll={{ x: 1800, y: 500 }}
        rowClassName={(record: IAepnUploadRecord) => (record?.errorMessage ? 'row-error' : '')}
      />
    </AppModalContainer>
  );
};

export default UploadDetailModal;
